import { parseISO } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";

const formatDate = (date, fmt, tz) => {
  const isoDate = parseISO(date);
  return format(utcToZonedTime(isoDate, tz), fmt, { timeZone: tz });
};

export default formatDate;
